import { useState } from 'react';
import SEOHead from '@/components/feature/SEOHead';
import JsonLd from '@/components/feature/JsonLd';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { faqData } from '@/mocks/faq';

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于盛世娱乐',
  description: '盛世娱乐是您首选的高端娱乐平台，汇聚丰富娱乐内容与专业服务。致力于为用户提供极致娱乐体验。',
  url: 'https://1616e.cn/about',
  isPartOf: {
    '@type': 'WebSite',
    name: '盛世娱乐官方平台',
    url: 'https://1616e.cn',
  },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: '首页',
      item: 'https://1616e.cn/',
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: '关于我们',
      item: 'https://1616e.cn/about',
    },
  ],
};

const milestones = [
  { year: '2018', title: '品牌创立', desc: '盛世娱乐正式成立，以"打造安全可靠的娱乐平台"为使命，开启高端在线娱乐新篇章。' },
  { year: '2019', title: '业务拓展', desc: '平台注册用户突破100万，娱乐项目扩展至六大板块，覆盖电子游艺、真人视讯、体育竞技等领域。' },
  { year: '2020', title: '技术升级', desc: '全面升级平台技术架构，引入国际认证随机数生成器，通过多项国际安全认证。' },
  { year: '2021', title: 'VIP体系上线', desc: '推出七级VIP会员体系，为高端用户提供专属客服、优先提现等尊享服务。' },
  { year: '2022', title: '行业领先', desc: '用户突破500万，荣获多项行业大奖，成为国内领先的高端娱乐平台。' },
  { year: '2023', title: '全球布局', desc: '拓展海外市场，支持多种语言和货币，服务全球用户。' },
  { year: '2024', title: '生态完善', desc: '完善娱乐生态系统，引入更多优质合作伙伴，打造一站式娱乐服务平台。' },
  { year: '2025', title: '持续创新', desc: '持续投入技术研发，推出多项创新功能，保持行业领先地位。' },
  { year: '2026', title: '再创辉煌', desc: '用户突破千万，盛世娱乐不忘初心，继续为每一位用户提供极致的娱乐体验。' },
];

export default function About() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <>
      <SEOHead
        title="关于我们 - 盛世娱乐官方平台 | 品牌介绍与联系方式"
        description="盛世娱乐是您首选的高端娱乐平台。了解盛世娱乐品牌故事、发展历程、平台信誉及联系方式。安全可靠的娱乐平台，千万用户信赖之选。"
        keywords="盛世娱乐,盛世娱乐官网,盛世娱乐平台,盛世娱乐品牌,盛世娱乐联系方式"
        canonicalUrl="https://1616e.cn/about"
        ogTitle="关于我们 - 盛世娱乐官方平台"
        ogDescription="了解盛世娱乐品牌故事、发展历程、平台信誉及联系方式。安全可靠的娱乐平台，千万用户信赖之选。"
      />
      <JsonLd data={aboutSchema} />
      <JsonLd data={breadcrumbSchema} />

      <main className="pt-16">
        {/* Page Header */}
        <section className="relative w-full h-[300px] md:h-[360px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Luxurious%20dark%20corporate%20headquarters%20interior%20with%20warm%20golden%20ambient%20lighting%2C%20elegant%20reception%20area%20with%20premium%20furnishings%2C%20sophisticated%20business%20atmosphere%2C%20dark%20wood%20and%20gold%20accents%2C%20professional%20corporate%20environment%2C%20refined%20aesthetic&width=1800&height=700&seq=about-header-2026&orientation=landscape"
              alt="关于盛世娱乐"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
          </div>
          <div className="relative z-10 text-center px-4">
            <h1 className="text-2xl md:text-4xl font-bold font-heading text-background-50 mb-3">
              关于我们
            </h1>
            <p className="text-sm md:text-base text-foreground-200 max-w-xl mx-auto">
              了解盛世娱乐的品牌故事与发展历程
            </p>
          </div>
        </section>

        {/* Breadcrumb */}
        <section className="bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于我们' }]} />
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row items-center gap-12">
              <div className="flex-1">
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-6">
                  盛世娱乐品牌介绍
                </h2>
                <div className="space-y-4">
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    盛世娱乐成立于2018年，是国内领先的高端在线娱乐平台。自创立以来，盛世娱乐始终秉持<strong>"以用户为中心，以安全为基石"</strong>的核心理念，致力于为全球用户提供极致、安全、便捷的娱乐体验。
                  </p>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    平台汇聚电子游艺、真人视讯、体育竞技、棋牌游戏、彩票游戏及电竞游戏六大娱乐板块，拥有超过千万注册用户。通过持续的技术创新和严格的安全保障体系，盛世娱乐已发展成为行业标杆级的高端娱乐平台。
                  </p>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    盛世娱乐采用国际认证的随机数生成器（RNG），所有游戏结果完全公平公正。平台持有合法运营资质，严格遵循国际娱乐行业标准，为用户打造值得信赖的娱乐环境。
                  </p>
                </div>
              </div>
              <div className="flex-1">
                <div className="relative w-full h-[350px] rounded-xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Luxurious%20golden%20brand%20identity%20concept%20with%20elegant%20geometric%20shapes%2C%20dark%20premium%20background%20with%20warm%20golden%20light%20rays%2C%20sophisticated%20corporate%20branding%20aesthetic%2C%20refined%20luxury%20atmosphere%2C%20professional%20business%20visual&width=800&height=600&seq=about-brand-2026&orientation=landscape"
                    alt="盛世娱乐品牌形象"
                    className="w-full h-full object-cover object-top rounded-xl"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-12 bg-background-100/50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {[
                { value: '1000万+', label: '注册用户' },
                { value: '6', label: '娱乐板块' },
                { value: '7×24', label: '全天候客服' },
                { value: '9年', label: '行业深耕' },
              ].map((stat) => (
                <div key={stat.label} className="text-center p-6">
                  <div className="text-2xl md:text-3xl font-bold font-heading text-primary-500 mb-2">
                    {stat.value}
                  </div>
                  <div className="text-sm text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Milestones */}
        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                发展历程
              </h2>
              <p className="text-sm text-foreground-600">
                自2018年成立以来，盛世娱乐一路前行，不断超越
              </p>
            </div>

            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-primary-200/60 transform md:-translate-x-px"></div>
              <div className="flex flex-col gap-8">
                {milestones.map((item, index) => (
                  <div
                    key={item.year}
                    className={`relative flex items-start gap-6 ${
                      index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                    }`}
                  >
                    <div className="hidden md:block flex-1"></div>
                    <div className="absolute left-2.5 md:left-1/2 w-3 h-3 bg-primary-500 rounded-full border-4 border-background-50 transform -translate-x-1/2 z-10"></div>
                    <div className="ml-10 md:ml-0 flex-1 bg-background-50 border border-background-200/60 rounded-xl p-5 hover:border-primary-300/50 transition-all duration-300">
                      <span className="text-xs font-bold text-primary-500 bg-primary-100/70 px-2.5 py-0.5 rounded-full">
                        {item.year}
                      </span>
                      <h3 className="text-base font-bold font-heading text-foreground-900 mt-2 mb-1">
                        {item.title}
                      </h3>
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="py-16 md:py-20 bg-background-100/50" id="contact">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                联系我们
              </h2>
              <p className="text-sm text-foreground-600 max-w-xl mx-auto">
                如有任何疑问或建议，欢迎通过以下方式与我们取得联系。我们的客服团队7×24小时为您服务。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
              <div className="bg-background-50 rounded-xl border border-background-200/60 p-6 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100/70 mx-auto mb-4">
                  <i className="ri-mail-line text-primary-500 text-xl"></i>
                </div>
                <h3 className="text-base font-bold font-heading text-foreground-900 mb-2">电子邮箱</h3>
                <p className="text-sm text-foreground-600">support@shengshientertainment.com</p>
                <p className="text-xs text-foreground-500 mt-1">工作日24小时内回复</p>
              </div>

              <div className="bg-background-50 rounded-xl border border-background-200/60 p-6 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100/70 mx-auto mb-4">
                  <i className="ri-phone-line text-primary-500 text-xl"></i>
                </div>
                <h3 className="text-base font-bold font-heading text-foreground-900 mb-2">客服热线</h3>
                <p className="text-sm text-foreground-600">400-888-9999</p>
                <p className="text-xs text-foreground-500 mt-1">7×24小时全天候服务</p>
              </div>

              <div className="bg-background-50 rounded-xl border border-background-200/60 p-6 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100/70 mx-auto mb-4">
                  <i className="ri-message-2-line text-primary-500 text-xl"></i>
                </div>
                <h3 className="text-base font-bold font-heading text-foreground-900 mb-2">在线客服</h3>
                <p className="text-sm text-foreground-600">官网在线聊天窗口</p>
                <p className="text-xs text-foreground-500 mt-1">即时响应，快速解决问题</p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-16 md:py-20 bg-background-50" id="faq">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                常见问题
              </h2>
              <p className="text-sm text-foreground-600">
                快速了解盛世娱乐，解答您的疑问
              </p>
            </div>

            <div className="flex flex-col gap-3">
              {faqData.map((item, index) => (
                <div
                  key={index}
                  className="bg-background-50 border border-background-200/60 rounded-xl overflow-hidden"
                >
                  <button
                    onClick={() => setOpenFaq(openFaq === index ? null : index)}
                    className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
                  >
                    <span className="text-sm font-medium text-foreground-900 pr-4">
                      {item.question}
                    </span>
                    <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openFaq === index ? 'rotate-180' : ''}`}>
                      <i className="ri-arrow-down-s-line text-foreground-500"></i>
                    </div>
                  </button>
                  {openFaq === index && (
                    <div className="px-6 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {item.answer}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}